import type { I18n } from '@learnforge/i18n';
import type { DemoKey } from './types';

export interface ActionButton {
  id: string;
  labelKey: DemoKey;
  onClick(): void;
  visible?: () => boolean;
  enabled?: () => boolean;
}

export interface ActionBarHandle {
  setButtons(buttons: readonly ActionButton[]): void;
  refresh(): void;
  destroy(): void;
}

export function mountActionBar(el: HTMLElement, i18n: I18n<DemoKey>): ActionBarHandle {
  let buttons: readonly ActionButton[] = [];
  const root = document.createElement('div');
  root.className = 'action-bar';
  el.replaceChildren(root);

  function refresh() {
    root.replaceChildren();
    for (const b of buttons) {
      if (b.visible && !b.visible()) continue;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = i18n.t(b.labelKey);
      btn.disabled = b.enabled ? !b.enabled() : false;
      btn.addEventListener('click', () => b.onClick());
      root.appendChild(btn);
    }
  }

  const unsub = i18n.subscribe(refresh);

  return {
    setButtons(next) {
      buttons = next;
      refresh();
    },
    refresh,
    destroy() {
      unsub();
      root.remove();
    },
  };
}
